<template>
  <b-container>
    <spinner />
    <div v-if="!isLoading">
      <h1 v-translate>Manage DAC</h1>
      <div class="row">
        <div class="col-md-3" >
          <company-navigation />
        </div>
        <div class="col-md-9 personal-info" v-if="hasMeliV2Integration">
          <h2>DAC - <translate>Configuration Panel</translate> </h2>
          <b-alert show variant="warning">
            <h3 v-translate>Important!</h3>
            <p v-translate>Once you click save your user will be <strong>disabled</strong>, only an admin user from DAC will be able to enable it again</p>
          </b-alert>

           <form @submit.stop.prevent="setIntegration" >
            <div class="form-group col-12" >
              <label for="reference">Username</label>
              <b-form-input type="number" id="username" name="username" v-model="integration.username" class="col-12" required/>
            </div>

            <div class="form-group col-12" >
              <label for="reference">Password</label>
              <b-form-input type="password" id="password" name="password" v-model="integration.password" class="col-12" required />
            </div>

            <div class="text-right mt-5">
              <b-button
                type="submit"
                variant="primary"
                size="lg"
                v-translate
              >Save</b-button>
            </div>
          </form>
        </div>
        <div class="col-md-9 personal-info" v-else >
          <b-alert show variant="danger">
            <h3 v-translate>Important!</h3>
            <p v-translate>You must integrate MELI before proceeding</p>
            </b-alert>
        </div>
      </div>
    </div>

  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Spinner from '@/components/Spinner'
import { FETCH_PROFILE } from '@/store/actions.type'
import CompanyNavigation from '../components/CompanyNavigation.vue'

export default {
  name: 'DacIntegrationPage',
  components: {
    Spinner,
    CompanyNavigation
  },
  data() {
    return {
      dataChanged: false,
      integration: {
        companyId: '',
        userId: '',
        username: '',
        password: ''
      },
      platformSlug: 'dac'
    }
  },
  props: { type: { type: String, default: 'ongoing' } },
  computed: {
    ...mapGetters(['user', 'isLoading'])
  },
  async beforeMount() {
    this.$store.dispatch(FETCH_PROFILE)
    this.getIntegration()
  },
  mounted() {
    this.$store.state.dashboard.isLoading = true
  },
  methods: {
    async getIntegration() {
      const path = `${this.$appConfig.integrations.ecommerce.baseUrl}${this.platformSlug}/authenticate-user?userId=${this.user.id}`
      const { data } = await this.$http.get(path, { before: this.changeAuth })
      this.integration = data
    },
    changeAuth(req) {
      req.headers.set('x-api-key', this.$appConfig.integrations.ecommerce.header)
      return req.headers.set('Authorization', this.application.key)
    },
    async logout() {
      await this.$http.post(this.$appConfig.api.baseUrl + 'logout')
      await this.$store.dispatch('logout')
      window.location.href = window.location.origin
    },
    async setIntegration() {
      const body = {
        appId: this.integration.username,
        appKey: this.integration.password,
        companyId: String(this.user.company_id),
        externalUserId: String(this.user.id)
      }
      const path = this.$appConfig.integrations.ecommerce.baseUrl + this.platformSlug + '/authenticate'
      const headers = { 'x-api-key': this.$appConfig.integrations.ecommerce.header }
      let message = {}
      try {
        await this.$http.post(path, body, { headers })
        await this.logout()
      } catch (error) {
        message = {
          title: 'ERROR',
          message: JSON.stringify(error.body),
          type: 'error',
          customCloseBtnText: this.$gettext('Close')
        }
        this.$root.$children[0].$refs.simplert.openSimplert(message)
      }
    }
  }
}
</script>
